export default "__VITE_PUBLIC_ASSET__5957e866__"